import { createFileRoute } from "@tanstack/react-router";
import { parseLang } from "@majourneys/shared";
import { TransportPage } from "../../../features/transport";
import { transferRoutesQueryOptions } from "../../../features/transport/api/transfers.api";
import { TRANSPORT_CITY } from "../../../features/transport/lib/routes";
import {
  parseTransportSearch,
  type TransportSearch,
} from "../../../features/transport/lib/transport-search";

export const Route = createFileRoute("/$lang/_layout/transport")({
  // `?route=<slug>` opens the hub with that ride picked in the quote bar. Every
  // old route page 301s here with it; an unknown slug is simply ignored.
  validateSearch: (search: Record<string, unknown>): TransportSearch => parseTransportSearch(search),
  // Prefetched so the quote bar and the route list are in the server HTML.
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      transferRoutesQueryOptions(TRANSPORT_CITY, parseLang(params.lang)),
    ),
  component: TransportPage,
});
